import jwt_decode from 'jwt-decode';

/** Returns JWT `exp` in milliseconds, or null if missing or malformed. */
export function getJwtExpMs(token: string): number | null {
  try {
    const decoded = jwt_decode(token) as { exp?: number };
    if (typeof decoded?.exp === 'number') {
      return decoded.exp * 1000;
    }
  } catch {
    // ignore
  }
  return null;
}

/** Console-friendly JWT expiry snapshot for WebSocket auth debugging. */
export function describeJwtToken(token: string | null | undefined, label = 'token') {
  const expMs = token ? getJwtExpMs(token) : null;
  const now = Date.now();
  return {
    label,
    expired: isJwtExpired(token, 0),
    expiringSoon: isJwtExpired(token, 60_000),
    expUtc: expMs ? new Date(expMs).toISOString() : 'unknown',
    msUntilExp: expMs != null ? expMs - now : null,
  };
}

/** True when the token is missing, unreadable, or within `skewMs` of expiry (default 60s). */
export function isJwtExpired(token: string | null | undefined, skewMs = 60_000): boolean {
  if (!token) {
    return true;
  }
  const expMs = getJwtExpMs(token);
  if (expMs == null) {
    return true;
  }
  return expMs <= Date.now() + skewMs;
}
